import React, { createContext, useContext, useMemo, useCallback } from 'react';
import useLocalStorage from '@msales/shared/hooks/useLocalStorage';
import localforage from 'localforage';
import moment from 'moment';
import { message } from 'antd';
import { useInsertEventLog } from '../hooks/useInsertEventLog';

export const Context = createContext({});

const clearCompletedSurveys = async () => {
  try {
    const store = localforage.createInstance({ name: 'Customers' });
    await store.removeItem('completedSurveysSession');
  } catch (error) {
    console.error('Greška prilikom resetovanja anketa.');
  }
};

export const Provider = (props) => {
  const { children } = props;
  const [dayStarted, setDayStarted] = useLocalStorage('dayStarted', null);
  const [lastStart, setLastStart] = useLocalStorage('lastStart', null);

  const { insertEvent } = useInsertEventLog();

  const startDay = useCallback(async () => {
    if (lastStart && moment().isSame(moment(lastStart), 'day')) {
      message.error('Već ste završili današnji dan!');
    } else {
      setDayStarted(moment());
      setLastStart(moment());
      await clearCompletedSurveys();
      try {
        await insertEvent({
          eventCode: '3',
        });
      } catch (error) {
        console.error('Greška prilikom bilježenja početka dana.');
      }
    }
  }, [lastStart, insertEvent]);

  const endDay = useCallback(async () => {
    setDayStarted(null);
    try {
      await insertEvent({
        eventCode: '4',
      });
    } catch (error) {
      console.error('Greška prilikom bilježenja kraja dana.');
    }
  }, [insertEvent]);

  const forceStartDay = useCallback(async () => {
    setDayStarted(moment());
    setLastStart(moment());
    await clearCompletedSurveys();
    try {
      await insertEvent({
        eventCode: '3',
      });
    } catch (error) {
      console.error('Greška prilikom bilježenja početka dana.');
    }
  }, [insertEvent]);

  const clearEvents = useCallback(() => {
    setDayStarted(null);
  }, []);

  const eventContext = useMemo(
    () => ({
      dayStarted,
      lastStart,
      startDay,
      endDay,
      forceStartDay,
      clearEvents,
    }),
    [dayStarted, lastStart, startDay, endDay, forceStartDay, clearEvents],
  );

  return <Context.Provider value={eventContext}>{children}</Context.Provider>;
};

export const { Consumer } = Context;

export const useEventContext = () => useContext(Context);
